export const modalTitles = {
  idle: 'web.wheel.spin.title',
  win: 'web.wheel.win.title',
  lose: ''
};
